import { usageTracker } from 'portals-platform-lib';
const NAMESPACE = 'Billing Portal';
export const trackPageView = subscreen => {
  usageTracker.track(NAMESPACE, 'Page Viewed', {
    subscreen
  });
};
export const trackInteraction = (action, properties) => {
  usageTracker.track(NAMESPACE, 'Interaction', Object.assign({
    action
  }, properties));
};